export default __webpack_public_path__ + "static/media/452.0a4184da.jpg";